import axios from "axios";

//state
export var lineState = {
  lines: [],
  line: {},
  status_line: ""
};

//getters
export var lineGetters = {
  //funciones para optener informacion del state
  getLines: state => state.lines
};

//actions
export var lineActions = {
  async getLines({ commit }) {
    commit("line_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.content_line", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'name', 'description', ('promotion_id', ['id', 'name']), ('campaign_id', ['id', 'name']), ('partner_id', ['id', 'name']), ('strategic_id', ['id', 'name'])]"
        }
      })
      .then(res => {
        var lines = res.data;
        commit("line_success", lines);
        return res;
      })
      .catch(err => {
        commit("line_error");
        return err;
      });
  },
  async newLine({ commit, state }, line) {
    commit("line_request");
    var { nameLine, descriptionLine } = line;
    var formData = new FormData();
    var newLine = `{'name':'${nameLine}','description': '${descriptionLine}'}`;
    formData.append("data", newLine);
    await this._vm.$http
      .post("/apache/rest_api/apache.content_line", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          line.id = res.data.id;
          line.name = line.nameLine;
          line.description = line.descriptionLine;
          var lines = state.lines;
          lines.push(line);
          commit("line_success", lines);
          return lines;
        } else {
          commit("line_error");
        }
      })
      .catch(err => {
        commit("line_error");
        return err;
      });
  },
  async editLine({ commit, state }, line) {
    commit("line_request");
    var { id, nameLine, descriptionLine } = line;
    var formData = new FormData();
    var newLine = `{'name':'${nameLine}','description': '${descriptionLine}'}`;
    formData.append("data", newLine);
    await this._vm.$http
      .put("/apache/rest_api/apache.content_line", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          line.id = id;
          line.name = line.nameLine;
          line.description = line.descriptionLine;
          var lines = state.lines;
          for (var i = 0; i < lines.length; i++) {
            if (lines[i].id == id) {
              index = i;
              lines[i] = line;
              break;
            }
          }
          lines.splice(index, 1);
          lines.splice(index, 0, line);
          commit("line_success", lines);
          return lines;
        } else {
          commit("line_error");
        }
      })
      .catch(err => {
        commit("line_error");
        return err;
      });
  },
  async deleteLine({ commit, state }, id) {
    commit("line_request");
    await this._vm.$http
      .delete(`/apache/rest_api/apache.content_line/${id}`, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          var lines = state.lines;
          for (var i = 0; i < lines.length; i++) {
            if (lines[i].id == id) {
              index = i;
              break;
            }
          }
          lines.splice(index, 1);
          commit("line_success", lines);

          return lines;
        } else {
          commit("line_error");
        }
      })
      .catch(err => {
        commit("line_error");
        return err;
      });
  },
  async deleteLineUtility({ commit, state }, id) {
    commit("line_request");
    var index;
    var lines = state.lines;
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].id == id) {
        index = i;
        break;
      }
    }
    lines.splice(index, 1);
    commit("line_success", lines);

    return lines;
  }
};

//mutations

export var lineMutations = {
  line_request(state) {
    state.status_line = "loading";
  },
  line_success(state, payload) {
    state.status_line = "success";
    state.lines = payload;
  },
  line_error(state) {
    state.status_line = "error";
  }
};
